import { Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import {
  UploadedFileErrorsRequest,
  UploadedFileErrorsResponse,
  UploadedFileFindAllRequest,
  UploadedFileFindAllResponse,
  UploadedFileFindRequest,
  UploadedFileFindResponse,
  UploadedFileSaveRequest,
  UploadedFileSaveResponse,
  UploadedFileTemplateDownloadResponse,
  UploadedFileTemplateDownloadRequest,
} from '../dto';

export abstract class UploadedFileRepository {
  abstract findAllPath(): string;
  abstract findAll(
    payload: UploadedFileFindAllRequest,
  ): Observable<HttpResponse<UploadedFileFindAllResponse>>;
  abstract find(payload: UploadedFileFindRequest): Observable<HttpResponse<UploadedFileFindResponse>>;
  abstract save(payload: UploadedFileSaveRequest): Observable<HttpResponse<UploadedFileSaveResponse>>;
  abstract findErrors(
    payload: UploadedFileErrorsRequest,
  ): Observable<HttpResponse<UploadedFileErrorsResponse>>;
  abstract downloadTemplate(
    request: UploadedFileTemplateDownloadRequest,
  ): Observable<HttpResponse<UploadedFileTemplateDownloadResponse>>;
}


